class TimeAuditedModel {
    constructor(data = {}) {
        this.created = data.created || null;
        this.modified = data.modified || null;
    }
}

export { TimeAuditedModel };
